import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chat-bot-icon',
  templateUrl: './chat-bot-icon.component.html',
  styleUrls: ['./chat-bot-icon.component.css']
})
export class ChatBotIconComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  featureUnderConstructionNavigation() {
    this.router.navigate([`under-construction`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component.ts